import { contractRequest } from "@/portals/clinician/api/transport";

// Module 4 — a patient's assigned clinician. patientId is the person_profiles id
// (works for dependents too). Failures go through the one contract error parser.

export interface AssignedClinician {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  assignedAt: string;
}

export interface PatientClinicianResponse {
  clinician: AssignedClinician | null;
}

const path = (patientId: string) => `/api/v1/admin/patients/${encodeURIComponent(patientId)}/clinician`;

export const getPatientClinicianApi = (patientId: string) =>
  contractRequest<PatientClinicianResponse>(path(patientId), { method: "GET", portal: "admin" });

/** 404 PATIENT_NOT_FOUND · 404 CLINICIAN_NOT_FOUND */
export const assignPatientClinicianApi = (patientId: string, clinicianUserId: string) =>
  contractRequest<PatientClinicianResponse>(path(patientId), { method: "PUT", portal: "admin", body: { clinicianUserId } });

export const removePatientClinicianApi = (patientId: string) =>
  contractRequest<PatientClinicianResponse>(path(patientId), { method: "DELETE", portal: "admin" });
